
import {Component, Prop, Vue} from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import PersonelForm from "@/components/forms/PersonelForm.vue";
import {DigerPersonelEntity} from "@/entity/DigerPersonelEntity";
import {AvukatEntity} from "@/entity/AvukatEntity";
import {PersonelTuruLabel} from "@/enum/PersonelTuru";

@Component({
  components: {FormDialog, PersonelForm}
})
export default class PersonelInfo extends Vue {
  @Prop()  item!:any;
  @Prop({}) action!: string;

  PersonelTuruLabel = PersonelTuruLabel

  load() {
    this.$emit('load')
  }
}
